import Objectives from 'components/common/Objectives'
import Text from './text.json'

export default ({ ...props }) => {
  return <Objectives title={Text.title} {...props} />
}
